  // Declare a flag to ensure the confetti triggers only once per 4pck selection
  let confettiTriggeredFor4pck = false;
  
  /***** Data Setup *****/
  const variants = {
    single: { variantId: 21174522675284, sellingPlan: 5116493961 },
    threePack: { variantId: 21174522708052, sellingPlan: 5116526729 },
    fourPack: { variantId: 39922146705545, sellingPlan: 5116362889 }
  };
  
  const bundleVariants = {
    antiAging: { variantId: 21136693493844, sellingPlan: 5116002441 },
    powerDad: { variantId: 40426830594185, sellingPlan: 5116231817 }
  };
  
  let currentTab = "buy";
  let selectedBuyVariantKey = "single";
  let selectedBundleVariantKey = "antiAging";
  let purchaseType = "subscription";
  
  // Frequency plan variables:
  let selectedFrequencyPlanId = "5116493961";          // for 1pck (blue)
  let selectedFrequencyPlanIdThreePack = "5116526729";   // for 3pck (orange)
  let selectedFrequencyPlanIdFourPack = "5116362889";    // for 4pck (red)
  
  /***** Update Subscribe Info (Buy Online) *****/
  function updateSubscribeInfo() {
    const subscribeInfo = document.querySelector('#bun-subscribe-btn .bun-subscribe-info');
    if (!subscribeInfo) return;
    const comparePriceSpan = subscribeInfo.querySelector('.bun-compare-price');
    const actualPriceSpan = subscribeInfo.querySelector('.bun-actual-price');
    if (selectedBuyVariantKey === 'single') {
      comparePriceSpan.textContent = "$52.99";
      actualPriceSpan.textContent = "$39.90";
    } else if (selectedBuyVariantKey === 'threePack') {
      comparePriceSpan.textContent = "$158.97";
      actualPriceSpan.textContent = "$113.05";
    } else if (selectedBuyVariantKey === 'fourPack') {
      comparePriceSpan.textContent = "$211.96";
      actualPriceSpan.textContent = "$148.20";
    }

updateCustomTitlesBasedOnSelection();

  }
  
  /***** Update OTP Info (Buy Online) *****/
  function updateOTPInfo() {
    const otpInfo = document.querySelector('#bun-otp-btn .bun-subscribe-info');
    if (otpInfo) {
const comparePriceSpan = otpInfo.querySelector('.bun-compare-price');
if (comparePriceSpan) comparePriceSpan.style.display = 'none';

      const actualPriceSpan = otpInfo.querySelector('.bun-actual-price');
      if (selectedBuyVariantKey === 'single') {
        comparePriceSpan.textContent = "$52.99";
        actualPriceSpan.textContent = "$52.99";
      } else if (selectedBuyVariantKey === 'threePack') {
        comparePriceSpan.textContent = "$158.97";
        actualPriceSpan.textContent = "$119.00";
      } else if (selectedBuyVariantKey === 'fourPack') {
        comparePriceSpan.textContent = "$211.96";
        actualPriceSpan.textContent = "$156.00";
      }
    }
    const bundleOtpInfo = document.querySelector('#bun-bundle-otp-btn .bun-subscribe-info');
    if (bundleOtpInfo) {
      const comparePriceSpan = bundleOtpInfo.querySelector('.bun-compare-price');
      const actualPriceSpan = bundleOtpInfo.querySelector('.bun-actual-price');
      if (selectedBuyVariantKey === 'single') {
        comparePriceSpan.textContent = "$52.99";
        actualPriceSpan.textContent = "$52.99";
      } else if (selectedBuyVariantKey === 'threePack') {
        comparePriceSpan.textContent = "$158.97";
        actualPriceSpan.textContent = "$119.00";
      } else if (selectedBuyVariantKey === 'fourPack') {
        comparePriceSpan.textContent = "$211.96";
        actualPriceSpan.textContent = "$156.00";
      }
    }
  }
  
  /***** Update Bundle Subscribe Info *****/
  function updateBundleSubscribeInfo() {
    const bundleSubscribeInfo = document.querySelector('#bun-bundle-subscribe-btn .bun-subscribe-info');
    if (!bundleSubscribeInfo) return;
    const comparePriceSpan = bundleSubscribeInfo.querySelector('.bun-compare-price');
    const actualPriceSpan = bundleSubscribeInfo.querySelector('.bun-actual-price');
    if (selectedBundleVariantKey === 'antiAging') {
      comparePriceSpan.textContent = "$71.99";
      actualPriceSpan.textContent = "$61.75";
    } else if (selectedBundleVariantKey === 'powerDad') {
      comparePriceSpan.textContent = "$119.95";
      actualPriceSpan.textContent = "$102.55";
    }

updateCustomTitlesBasedOnSelection();

  }
  
  /***** Update Bundle OTP Info *****/
  function updateBundleOTPInfo() {
    const bundleOtpInfo = document.querySelector('#bun-bundle-otp-btn .bun-subscribe-info');
    if (!bundleOtpInfo) return;
const comparePriceSpan = bundleOtpInfo.querySelector('.bun-compare-price');
if (comparePriceSpan) comparePriceSpan.style.display = 'none';

    const actualPriceSpan = bundleOtpInfo.querySelector('.bun-actual-price');
    if (selectedBundleVariantKey === 'antiAging') {
      comparePriceSpan.textContent = "$71.99";
      actualPriceSpan.textContent = "$65.00";
    } else if (selectedBundleVariantKey === 'powerDad') {
      comparePriceSpan.textContent = "$119.95";
      actualPriceSpan.textContent = "$107.95";
    }
  }
  
  /***** Update Add to Cart Button (Buy Online) *****/
  function updateAddToCartButton() {
    const btn = document.getElementById('bun-add-to-cart-btn');
    let price = "";
    if (document.getElementById('bun-subscribe-btn').classList.contains('active')) {
      if (selectedBuyVariantKey === 'single') {
        price = "$39.90";
      } else if (selectedBuyVariantKey === 'threePack') {
        price = "$113.05";
      } else if (selectedBuyVariantKey === 'fourPack') {
        price = "$148.20";
      }
    } else {
      if (selectedBuyVariantKey === 'single') {
        price = "$52.99";
      } else if (selectedBuyVariantKey === 'threePack') {
        price = "$119.00";
      } else if (selectedBuyVariantKey === 'fourPack') {
        price = "$156.00";
      }
    }
    btn.textContent = "Add to cart – " + price;
  }
  
  /***** Update Add to Cart Button (Bundle) *****/
  function updateBundleAddToCartButton() {
    const btn = document.getElementById('bun-bundle-add-to-cart-btn');
    let price = "";
    if (document.getElementById('bun-bundle-subscribe-btn').classList.contains('active')) {
      if (selectedBundleVariantKey === 'antiAging') {
        price = "$61.75";
      } else if (selectedBundleVariantKey === 'powerDad') {
        price = "$102.55";
      }
    } else {
      if (selectedBundleVariantKey === 'antiAging') {
        price = "$65.00";
      } else if (selectedBundleVariantKey === 'powerDad') {
        price = "$107.95";
      }
    }
    btn.textContent = "Add to cart – " + price;
  }

/***** Update Custom Titles Based on Selection *****/
function updateCustomTitlesBasedOnSelection() {
  const custTitle = document.querySelector('.cust-title');
  const custSubTitle = document.querySelector('.cust-sub-title');
  const custSubTitle2 = document.querySelector('.cust-sub-title-2');

  if (!custTitle || !custSubTitle || !custSubTitle2) return;

  if (currentTab === "bundle") {
    if (selectedBundleVariantKey === 'antiAging') {
      custTitle.textContent = "Anti Aging Bundle";
      custSubTitle.textContent = "NAD+ & Sirtuin Activation";
      custSubTitle2.textContent = "30 Day Supply";
    } else if (selectedBundleVariantKey === 'powerDad') {
      custTitle.textContent = "The Power Dad Stack";
      custSubTitle.textContent = "T-Booster & NAD3®";
      custSubTitle2.textContent = "1 Month Supply";
    }
  } else if (currentTab === "buy") {
    if (selectedBuyVariantKey === 'single') {
      custTitle.textContent = "NAD3® | 1 Month Supply";
      custSubTitle.textContent = "Cellular Health & Longevity";
      custSubTitle2.textContent = "60 Capsules | 312mg per serving";
    } else if (selectedBuyVariantKey === 'threePack') {
      custTitle.textContent = "NAD3® | 3 Month Supply";
      custSubTitle.textContent = "Cellular Health & Longevity";
      custSubTitle2.textContent = "180 Capsules | 312mg per serving";
    } else if (selectedBuyVariantKey === 'fourPack') {
      custTitle.textContent = "NAD3® | 4 Month Supply";
      custSubTitle.textContent = "Cellular Health & Longevity";
      custSubTitle2.textContent = "240 Capsules | 312mg per serving";
    }
  }
}

  
  /***** Update Banner, Highlight List, and Free Gift Visibility *****/
function updateBannerAndHighlight() {
  const saveBanner   = document.getElementById('save-banner');
  const highlightList = document.querySelector('#bun-subscribe-btn .bun-highlight-list');
  const freeGiftRow  = document.querySelector('.free-gift-row');

  // 1) Update the "Save X%" banner
  if (saveBanner) {
    if (selectedBuyVariantKey === 'single')    saveBanner.textContent = 'Save 25%';
    if (selectedBuyVariantKey === 'threePack') saveBanner.textContent = 'Save 29%';
    if (selectedBuyVariantKey === 'fourPack')  saveBanner.textContent = 'Save 30%';
  }

  // 2) Rebuild the highlight-list HTML
  if (!highlightList) return;
  let html = `<li>Save ${
    selectedBuyVariantKey === 'single'    ? '25%' :
    selectedBuyVariantKey === 'threePack' ? '29%' :
    '30%'} forever</li>`;

  // only include shipping line for 3‑pack & 4‑pack
  if (selectedBuyVariantKey !== 'single') {
    html += '<li>Free U.S. shipping (excluding NY)</li>';
  }

  html += '<li>Free longevity eBook <span class="sml-banner">$20 Value</span></li>';

  if (selectedBuyVariantKey === 'threePack') {
    html += '<li>Free Shaker <span class="sml-banner">$15 Value</span></li>';
  } else if (selectedBuyVariantKey === 'fourPack') {
    html += `
      <li>Free Shaker <span class="sml-banner">$15 Value</span></li>
      <li>Free S9<span style="font-size:10px;vertical-align:super;">®</span> <span class="sml-banner">$30 Value</span></li>
    `;
  }

  html += '<li>No commitments, cancel anytime</li>';
  highlightList.innerHTML = html;

  // 3) Show/hide the free‑gift row as before
  if (freeGiftRow) {
    freeGiftRow.style.display = (selectedBuyVariantKey === 'fourPack') ? 'flex' : 'none';
  }
}

  
  /***** Update Progress Bar *****/
  function updateProgressBar() {
    const progressFill = document.querySelector('.bun-progress-bar-fill');
    if (!progressFill) return;
    if (selectedBuyVariantKey === 'single') {
      progressFill.style.width = "33.33%";
    } else if (selectedBuyVariantKey === 'threePack') {
      progressFill.style.width = "66.66%";
    } else if (selectedBuyVariantKey === 'fourPack') {
      progressFill.style.width = "100%";
    }
  }
  
  /***** Update Progress Row Display *****/
  function updateProgressRowDisplay() {
    const defaultProgressRow = document.querySelector('.bun-progress-bar-row');
    const freeProgressRow = document.querySelector('.bun-free-progress-row');
    if (selectedBuyVariantKey === 'fourPack') {
      defaultProgressRow.style.display = 'none';
      freeProgressRow.style.display = 'flex';
      if (!confettiTriggeredFor4pck) {
        confetti({
          particleCount: 50,
          spread: 60,
          origin: { x: 0.5, y: 0.45 },
          colors: ['#082944', '#ffc106', '#3f84ae']
        });
        confettiTriggeredFor4pck = true;
      } else {
        freeProgressRow.classList.add('blink');
        setTimeout(() => {
          freeProgressRow.classList.remove('blink');
        }, 1000);
      }
    } else {
      defaultProgressRow.style.display = 'block';
      freeProgressRow.style.display = 'none';
    }
  }

  /***** Update Custom Titles *****/
  function updateCustomTitles() {
    const custTitle = document.querySelector('.cust-title');
    const custSubTitle2 = document.querySelector('.cust-sub-title-2');
    if (!custTitle || !custSubTitle2) return;
    
    if (selectedBuyVariantKey === 'threePack') {
      custTitle.textContent = "NAD3® | 3 Month Supply";
      custSubTitle2.textContent = "60 Capsules | 312mg per serving";
    } else if (selectedBuyVariantKey === 'fourPack') {
      custTitle.textContent = "NAD3® | 4 Month Supply";
      custSubTitle2.textContent = "240 Capsules | 312mg per serving";
    } else {
      custTitle.textContent = "NAD3® | 1 Month Supply";
      custSubTitle2.textContent = "60 Capsules | 312mg per serving";
    }
  }

  /***** Generic Toggle Image Update *****/
  function updateToggleImageForId(id) {
    const el = document.getElementById(id);
    if (el) {
      const img = el.querySelector('.bun-toggle-icon');
      if (img) {
        if (el.classList.contains('active')) {
          if (id.includes("bun-bundle")) {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Selected.png?v=1741908329";
          } else {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Selected.png?v=1741909396";
          }
        } else {
          if (id.includes("bun-bundle")) {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Unselected.png?v=1741908329";
          } else {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Unselected.png?v=1741909396";
          }
        }
      }
    }
  }

/***** Update OCU Button Visibility *****/
function updateOCUButtonVisibility() {
  // First, hide all OCU forms and the original add-to-cart button
  document.getElementById('custom-add-to-cart-form-variant1').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant1-subscription').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant2').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant2-subscription-30').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant2-subscription-90').style.display = 'none';
  document.getElementById('bun-add-to-cart-btn').style.display = 'none';

  // For 1pck (single):
  if (selectedBuyVariantKey === 'single') {
    if (purchaseType === "subscription") {
      document.getElementById('custom-add-to-cart-form-variant1-subscription').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant1-subscription');
    } else {
      document.getElementById('custom-add-to-cart-form-variant1').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant1');
    }
  }
  // For 3pck:
  else if (selectedBuyVariantKey === 'threePack') {
    if (purchaseType === "subscription") {
      // Check which frequency plan is selected for 3pck:
      if (selectedFrequencyPlanIdThreePack === "5116493961") {
        document.getElementById('custom-add-to-cart-form-variant2-subscription-30').style.display = 'block';
        window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2-subscription-30');
      } else if (selectedFrequencyPlanIdThreePack === "5116526729") {
        document.getElementById('custom-add-to-cart-form-variant2-subscription-90').style.display = 'block';
        window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2-subscription-90');
      } else {
        // Default if frequency isn’t explicitly set:
        document.getElementById('custom-add-to-cart-form-variant2-subscription-30').style.display = 'block';
        window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2-subscription-30');
      }
    } else {
      document.getElementById('custom-add-to-cart-form-variant2').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2');
    }
  }
  // For 4pck:
  else if (selectedBuyVariantKey === 'fourPack') {
    // When 4pck is selected, show the original add-to-cart button instead of any custom OCU forms.
    document.getElementById('bun-add-to-cart-btn').style.display = 'block';
    window.selectedOCUForm = null;
  }
}


  
  /***** Tab Switching *****/
  const tabBuy = document.getElementById('bun-tab-buy');
  const tabBundle = document.getElementById('bun-tab-bundle');
  const buyContainer = document.getElementById('bun-buy-online-container');
  const bundleContainer = document.getElementById('bun-bundle-save-container');
  
  function switchTab(tab) {
    currentTab = tab;
    if (tab === "buy") {
      tabBuy.classList.add('active');
      tabBundle.classList.remove('active');
      buyContainer.style.display = 'block';
      bundleContainer.style.display = 'none';
    } else {
      tabBuy.classList.remove('active');
      tabBundle.classList.add('active');
      buyContainer.style.display = 'none';
      bundleContainer.style.display = 'block';
    }

updateCustomTitlesBasedOnSelection();

  }
  
  tabBuy.addEventListener('click', () => switchTab("buy"));
  tabBundle.addEventListener('click', () => switchTab("bundle"));
  
  /***** Variant Selection *****/
  const variantButtons = document.querySelectorAll('.bun-variant-button');
  
variantButtons.forEach(button => {
  button.addEventListener('click', function() {
    const containerId = this.closest('.bun-container').id;
    // Remove active state from all buttons in this container, then mark this button as active
    this.closest('.bun-container').querySelectorAll('.bun-variant-button').forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');

    if (containerId === "bun-buy-online-container") {
      selectedBuyVariantKey = this.getAttribute('data-variant');
      

      // Assign the correct OCU popup form based on the selected variant:
      if (selectedBuyVariantKey === 'single') {
        window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant1');
        
      } else if (selectedBuyVariantKey === 'threePack') {
        window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2');
        
      } else if (selectedBuyVariantKey === 'fourPack') {
        // If needed, you can also assign a form for fourPack. For now, defaulting to Variant 2's form.
        window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2');
        
      }

      // Continue with other updates...
      updateFrequencyButtons();
      updateSubscribeInfo();
      updateOTPInfo();
      updateBannerAndHighlight();
      updateProgressBar();
      updateProgressRowDisplay();
      updateAddToCartButton();
      updateCustomTitles(); // update titles based on the variant selected
updateOCUButtonVisibility();
    } else if (containerId === "bun-bundle-save-container") {
      selectedBundleVariantKey = this.getAttribute('data-variant');
      
      updateBundleSubscribeInfo();
      updateBundleOTPInfo();
      updateBundleAddToCartButton();
    }
  });

  updateCustomTitlesBasedOnSelection();
});

  
  /***** Purchase Type Toggle *****/
  const subscribeBtn = document.getElementById('bun-subscribe-btn');
  const otpBtn = document.getElementById('bun-otp-btn');
  
  subscribeBtn.addEventListener('click', () => {
    subscribeBtn.classList.add('active');
    otpBtn.classList.remove('active');
    purchaseType = "subscription";
    
    updateFrequencyButtons();
    updateToggleImageForId('bun-subscribe-btn');
    updateToggleImageForId('bun-otp-btn');
    updateBannerAndHighlight();
    updateAddToCartButton();
updateOCUButtonVisibility();
  });
  
  otpBtn.addEventListener('click', () => {
    otpBtn.classList.add('active');
    subscribeBtn.classList.remove('active');
    purchaseType = "otp";
    
    updateFrequencyButtons();
    updateToggleImageForId('bun-subscribe-btn');
    updateToggleImageForId('bun-otp-btn');
    updateBannerAndHighlight();
    updateAddToCartButton();
updateOCUButtonVisibility();
  });
  
  const bundleSubscribeBtn = document.getElementById('bun-bundle-subscribe-btn');
  const bundleOtpBtn = document.getElementById('bun-bundle-otp-btn');
  
  bundleSubscribeBtn.addEventListener('click', () => {
    bundleSubscribeBtn.classList.add('active');
    bundleOtpBtn.classList.remove('active');
    purchaseType = "subscription";
    
    updateToggleImageForId('bun-bundle-subscribe-btn');
    updateToggleImageForId('bun-bundle-otp-btn');
    updateBundleAddToCartButton();
  });
  
  bundleOtpBtn.addEventListener('click', () => {
    bundleOtpBtn.classList.add('active');
    bundleSubscribeBtn.classList.remove('active');
    purchaseType = "otp";
    
    updateToggleImageForId('bun-bundle-subscribe-btn');
    updateToggleImageForId('bun-bundle-otp-btn');
    updateBundleAddToCartButton();
  });
  
  /***** Frequency Buttons Update *****/
  function updateFrequencyButtons() {
    const frequencyOptions = document.getElementById('bun-frequency-options');
    if (purchaseType !== "subscription") {
      frequencyOptions.style.display = 'none';
      return;
    }
    frequencyOptions.style.display = 'flex';
    document.querySelectorAll('#bun-frequency-options .bun-frequency-set').forEach(set => {
      set.style.display = 'none';
    });
    if (selectedBuyVariantKey === 'single') {
      let blueSet = document.querySelector('#bun-frequency-options .bun-frequency-set--blue');
      blueSet.style.display = 'flex';
      blueSet.querySelectorAll('.bun-frequency-button').forEach((btn, index) => {
        if (index === 0) {
          btn.classList.add('active');
          btn.classList.remove('disabled');
          btn.style.pointerEvents = "auto";
          selectedFrequencyPlanId = btn.getAttribute('data-plan-id');
        } else {
          btn.classList.remove('active');
          btn.classList.add('disabled');
          btn.style.pointerEvents = "none";
        }
      });
    } else if (selectedBuyVariantKey === 'threePack') {
      let orangeSet = document.querySelector('#bun-frequency-options .bun-frequency-set--orange');
      orangeSet.style.display = 'flex';
      orangeSet.querySelectorAll('.bun-frequency-button').forEach((btn, index) => {
        if (index === 2) {
          btn.classList.add('disabled');
          btn.style.pointerEvents = "none";
        } else {
          btn.classList.remove('disabled');
          btn.style.pointerEvents = "auto";
        }
        btn.classList.remove('active');
      });
      let btnToActivate = orangeSet.querySelector(`.bun-frequency-button[data-plan-id="${selectedFrequencyPlanIdThreePack}"]`);
      if (!btnToActivate) {
        let buttons = orangeSet.querySelectorAll('.bun-frequency-button');
        btnToActivate = buttons[1];
        selectedFrequencyPlanIdThreePack = btnToActivate.getAttribute('data-plan-id');
      }
      btnToActivate.classList.add('active');
    } else if (selectedBuyVariantKey === 'fourPack') {
      let redSet = document.querySelector('#bun-frequency-options .bun-frequency-set--red');
      redSet.style.display = 'flex';
      redSet.querySelectorAll('.bun-frequency-button').forEach(btn => {
        btn.classList.remove('disabled');
        btn.style.pointerEvents = "auto";
        btn.classList.remove('active');
      });
      let btnToActivate = redSet.querySelector(`.bun-frequency-button[data-plan-id="${selectedFrequencyPlanIdFourPack}"]`);
      if (!btnToActivate) {
        let buttons = redSet.querySelectorAll('.bun-frequency-button');
        btnToActivate = buttons[2];
        selectedFrequencyPlanIdFourPack = btnToActivate.getAttribute('data-plan-id');
      }
      btnToActivate.classList.add('active');
    }
  }
  
  document.querySelectorAll('.bun-frequency-set--blue .bun-frequency-button').forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (selectedBuyVariantKey === 'single') {
        selectedFrequencyPlanId = this.getAttribute('data-plan-id');
        
      }
    });
  });
  
  document.querySelectorAll('.bun-frequency-set--orange .bun-frequency-button').forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (selectedBuyVariantKey === 'threePack') {
        selectedFrequencyPlanIdThreePack = this.getAttribute('data-plan-id');
        
      }
    });
  });
  
  document.querySelectorAll('.bun-frequency-set--red .bun-frequency-button').forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (selectedBuyVariantKey === 'fourPack') {
        selectedFrequencyPlanIdFourPack = this.getAttribute('data-plan-id');
        
      }
    });
  });
  
  /***** Add to Cart Functionality *****/
  function addToCart(purchaseType) {
    let payload;
    if (currentTab === "buy") {
      const variantData = variants[selectedBuyVariantKey];
      if (purchaseType === "subscription") {
        if (selectedBuyVariantKey === 'single') {
          payload = { id: variantData.variantId, quantity: 1, selling_plan: selectedFrequencyPlanId };
        } else if (selectedBuyVariantKey === 'threePack') {
          payload = { id: variantData.variantId, quantity: 1, selling_plan: selectedFrequencyPlanIdThreePack };
        } else if (selectedBuyVariantKey === 'fourPack') {
          payload = { id: variantData.variantId, quantity: 1, selling_plan: selectedFrequencyPlanIdFourPack };
        }
      } else {
        payload = { id: variantData.variantId, quantity: 1 };
      }
    } else {
      if (purchaseType === "subscription") {
        if (selectedBundleVariantKey === "antiAging") {
          payload = { id: bundleVariants.antiAging.variantId, quantity: 1, selling_plan: bundleVariants.antiAging.sellingPlan };
        } else if (selectedBundleVariantKey === "powerDad") {
          payload = { id: bundleVariants.powerDad.variantId, quantity: 1, selling_plan: bundleVariants.powerDad.sellingPlan };
        }
      } else {
        const variantData = bundleVariants[selectedBundleVariantKey];
        payload = { id: variantData.variantId, quantity: 1 };
      }
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(data => {
      
      window.location.href = '/cart';
    });
  }
  
  document.getElementById('bun-add-to-cart-btn').addEventListener('click', () => { addToCart(purchaseType); });
  document.getElementById('bun-bundle-add-to-cart-btn').addEventListener('click', () => { addToCart(purchaseType); });

// Ensure default OCU form is set if not already assigned
if (!window.selectedOCUForm) {
  window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant1');
  
}


  // Initialize all components on page load.
  updateFrequencyButtons();
  updateSubscribeInfo();
  updateOTPInfo();
  updateBannerAndHighlight();
  updateProgressBar();
  updateProgressRowDisplay();
  updateAddToCartButton();
  updateBundleAddToCartButton();
  updateToggleImageForId('bun-subscribe-btn');
  updateToggleImageForId('bun-otp-btn');
  updateToggleImageForId('bun-bundle-otp-btn');
  updateBundleSubscribeInfo();
  updateBundleOTPInfo();
updateOCUButtonVisibility();
// BEFORE REPLACEMENT
